// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"SearchOverlay_backdrop__IBQaD","show":"SearchOverlay_show___nJKn","overlay":"SearchOverlay_overlay__VG8_v","searchResults":"SearchOverlay_searchResults__NknaW"};